import React, { memo } from "react";

const PaginationForward = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="25"
    viewBox="0 0 11 25"
  >
    <text
      id="_"
      data-name="&gt;"
      transform="translate(0 19)"
      fill="#666"
      fontSize="18"
      fontFamily="Poppins-Medium, Poppins"
      fontWeight="500"
    >
      <tspan x="0" y="0">
        &gt;
      </tspan>
    </text>
  </svg>
);

export default memo(PaginationForward);
